export default [
  {
    path: "/reports/submissions/quarterly-procurement",
    name: "quarterly-procurement-submissions",
    meta: { title: "Quarterly Procurement Reports", authRequired: true, reportCode: "QPR-DETAILED" },
    component: () => import("../views/report-submissions/index.vue"),
  },
  {
    path: "/reports/submissions/monthly-direct-bidding",
    name: "monthly-direct-bidding-submissions",
    meta: { title: "Monthly Direct Bidding Reports", authRequired: true, reportCode: "MONTHLY-DIRECT-BIDDING" },
    component: () => import("../views/report-submissions/index.vue"),
  },
  {
    path: "/reports/submissions/monthly-deviation",
    name: "monthly-deviation-submissions",
    meta: { title: "Monthly Deviation Reports", authRequired: true, reportCode: "MONTHLY-DEVIATION-REPORT" },
    component: () => import("../views/report-submissions/index.vue"),
  },
  {
    path: "/reports/submissions",
    name: "report-submissions",
    meta: {
      title: "Reports and Submissions",
      authRequired: true,
    },
    component: () => import("../views/report-submissions/index.vue"),
  },
  {
    path: "/reports/submissions/:submissionId",
    name: "report-submission-workspace",
    meta: {
      title: "Report Submission",
      authRequired: true,
    },
    component: () => import("../views/report-submissions/workspace.vue"),
  },
  {
    path: "/reports/submissions/:submissionId/review",
    name: "report-submission-review",
    meta: {
      title: "Review Report Changes",
      authRequired: true,
    },
    component: () => import("../views/report-submissions/review.vue"),
  },
  {
    path: "/reports/submissions/:submissionId/certification",
    name: "report-submission-certification",
    meta: {
      title: "Certify and Submit Report",
      authRequired: true,
    },
    component: () => import("../views/report-submissions/certification.vue"),
  },
];
